/* Exact 2026-10-15 release scope. Does not reserve or write inventory. */
(() => {
  const productIds = Object.freeze([
    '12658092278078', '12658092212542', '12658092081470',
    '12644492247358', '12644492214590', '12644492181822',
    '12560860905790', '12560860807486', '12560860774718',
    '12560860741950', '12560860643646', '12560860610878',
    '12560860512574', '12560860479806', '12560860348734',
    '12560860283198', '12560310862142', '12555828003134', '12555827970366',
  ]);
  const ids = new Set(productIds);
  const isLimited = item => ids.has(String(item.product_id));
  const invoiceCart = cart => {
    const items = cart.items.filter(item => !isLimited(item));
    return { ...cart, items, total_price: items.reduce((total, item) => total + item.final_line_price, 0) };
  };
  const signature = cart => JSON.stringify(cart.items.map(item => [
    item.key || String(item.variant_id), item.quantity, item.final_line_price,
  ]).sort((a, b) => a[0].localeCompare(b[0])));
  async function removeInvoicedLines(fetchCart, submittedItems) {
    const response = await fetchCart('/cart.js');
    if (!response.ok) throw new Error('CART_READ_FAILED');
    const current = await response.json();
    const updates = Object.create(null);
    for (const submitted of submittedItems) {
      if (isLimited(submitted)) throw new Error('LIMITED_LINE_CLEANUP_FORBIDDEN');
      const line = current.items.find(item => item.key === submitted.key);
      if (!submitted.key || !line) continue;
      updates[submitted.key] = Math.max(0, line.quantity - submitted.quantity);
    }
    if (!Object.keys(updates).length) return;
    const result = await fetchCart('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }),
    });
    if (!result.ok) throw new Error('CART_UPDATE_FAILED');
    const after = await result.json();
    for (const [key, quantity] of Object.entries(updates)) {
      if ((after.items.find(item => item.key === key)?.quantity || 0) !== quantity) {
        throw new Error('CART_UPDATE_UNCONFIRMED');
      }
    }
  }
  function needsModeReload(cart) {
    if (typeof document === 'undefined' || document.body?.dataset.jcB2b !== 'true' || !cart?.items) return false;
    const limitedOnly = cart.items.length > 0 && cart.items.every(isLimited);
    return limitedOnly !== (document.body.dataset.jcLimitedOnly === 'true');
  }
  globalThis.SakuraJcLimited = Object.freeze({ productIds, isLimited, invoiceCart, signature, removeInvoicedLines, needsModeReload });
  if (typeof document !== 'undefined') document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (needsModeReload(event.cartData)) location.reload();
      });
    }
  });
})();
